export const toLabelDataTestIdSuffix = (label: string): string =>
  label.replace(/:\s?/g, '-');
